export const UserTypes = {
    create       : 'User_create',
    updateProfile: 'User_updateProfile',
    deleteProfile: 'User_deleteProfile',
}
